export const isMaterialOrDamageChosen = (choosenSideDamages, choosenMaterial, choosenMaterialname) => {
	return choosenSideDamages.damages.length !== 0 && choosenMaterial === choosenMaterialname.name ? true : false;
};
